<template>
  <div class="addCardPos">
    <nav-bar title="添加上车位置"></nav-bar>
    <van-cell>
      <template slot="title">
        <span>北京市</span>
        <van-icon class-prefix="iconfont" name="icon-xiala" />
        <div class="divider"></div>
        <input type="text" class="ipt" placeholder="地铁5号线，地铁13号线" />
      </template>
    </van-cell>
    <div class="content">
      <p>允许员工在地点多少米范围内用车</p>
      <div class="selectItem">
        <div
          :class="[{ item: true, select: index == i }]"
          v-for="(value, i) in positionList"
          :key="i"
          @click="selectPosHandel(i)"
        >
          {{ value.text }}
        </div>
      </div>
      <van-field
        class="iptPos"
        v-model="value"
        label="位置别名"
        input-align="right"
        placeholder="请输入位置别名"
      />
      <van-cell class="selsecPro" title="选择项目" is-link />
    </div>
    <van-button type="default" block>保存</van-button>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import { Cell, Icon, Field, Button } from "vant";

export default {
  name: "addPosition",
  data() {
    return {
      index: null,
      positionList: [
        {
          text: "100米"
        },
        {
          text: "200米"
        },
        {
          text: "500米"
        },
        {
          text: "1000米"
        },
        {
          text: "1500米"
        },
        {
          text: "2000米"
        }
      ]
    };
  },
  components: {
    NavBar,
    "van-icon": Icon,
    "van-cell": Cell,
    "van-field": Field,
    "van-button": Button
  },
  methods: {
    // 选择范围操作
    selectPosHandel(index) {
      this.index = index;
    }
  }
};
</script>

<style scoped lang="less">
.addCardPos {
  overflow: hidden;
  height: 100%;
}
.iconfont-icon-xiala {
  vertical-align: middle;
}

.divider {
  display: inline-block;
  width: 1px;
  height: 15px;
  background-color: #ccc;
  vertical-align: middle;
  margin: 0 20px;
}

.ipt {
  width: 240px;
  background-color: #eee;
  border: 0;
  height: 30px;
  padding-left: 16px;
  box-sizing: border-box;
}

.content {
  padding: 0 20px;

  p {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(33, 37, 41, 1);
  }
}

.selectItem {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .item {
    width: 108px;
    height: 28px;
    border-radius: 6px;
    border: 1px solid rgba(232, 233, 235, 1);
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(98, 104, 112, 1);
    text-align: center;
    line-height: 28px;
    margin-bottom: 10px;
  }

  .select {
    background: rgba(255, 149, 0, 0.1);
    border-radius: 6px;
    color: rgba(255, 149, 0, 1);
    border: 1px solid rgba(255, 149, 0, 1);
  }
}

.color {
  border-color: blue !important;
  color: blue !important;
}

.van-button {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: 325px;
  height: 44px;
  background: rgba(33, 37, 41, 1);
  border-radius: 6px;
  opacity: 0.3;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.iptPos {
  padding-left: 0;
  padding-right: 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(158, 160, 165, 1);
}
.selsecPro {
  padding-left: 0;
  padding-right: 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(158, 160, 165, 1);
}
</style>
